<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <mat-icon class="delete-icon">delete</mat-icon>
  <span class="title-text">{{ deletedRide().rideData.title }}</span>
  <div class="title-buttons">
    <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h1>

<mat-dialog-content>
  <div class="deleted-ride-badge">Verwijderde rit</div>
  <h3>Bewerkingen</h3>
  <h4 class="order-title">Nieuwste - oudste</h4>
  <div class="edit-item">
    <div>
      <p><b>Bewerker:</b></p>
      <p><b>Actie:</b></p>
      <p><b>Reden:</b></p>
    </div>
    <div class="action-list">
      <p class="edit-info">
        <span>{{ deletedRide().doneByUser }}</span>
        <span>{{ deletedRide().date.toDate() | date: 'short' }}</span>
      </p>
      <p>Rit verwijderd</p>
      <p>
        <b>{{ deletedRide().deleteReason && deletedRide().deleteReason != '' ? deletedRide().deleteReason : '-' }}</b>
      </p>
    </div>
  </div>
  @for (edit of allEdits(); track edit.id) {
    @for (change of edit.changes; track change) {
      @if (change.field === 'addedUsers') {
        <div class="edit-item">
          <div>
            <p><b>Bewerker:</b></p>
            <p><b>Actie:</b></p>
            <p><b>Bewerking:</b></p>
          </div>
          <div class="action-list">
            <p class="edit-info">
              <span>{{ edit.editedByEmail }}</span>
              <span>{{ edit.date.toDate() | date: 'short' }}</span>
            </p>
            <p>Personen toegevoegd</p>
            @for (user of change.users; track user) {
              <div>
                <p>
                  <b>{{ user.title }}</b>
                </p>
              </div>
            }
          </div>
        </div>
      }
      @if (change.field === 'createdRide') {
        <div class="edit-item">
          <div>
            <p><b>Bewerker:</b></p>
            <p><b>Actie:</b></p>
          </div>
          <div class="action-list">
            <p class="edit-info">
              <span>{{ edit.editedByEmail }}</span>
              <span>{{ edit.date.toDate() | date: 'short' }}</span>
            </p>
            <p>{{ change.text }}</p>
          </div>
        </div>
      }
      @if (change.field === 'copiedRide') {
        <div class="edit-item">
          <div>
            <p><b>Bewerker:</b></p>
            <p><b>Actie:</b></p>
          </div>
          <div class="action-list">
            <p class="edit-info">
              <span>{{ edit.editedByEmail }}</span>
              <span>{{ edit.date.toDate() | date: 'short' }}</span>
            </p>
            <p>{{ change.text }}</p>
          </div>
        </div>
      }
      @if (change.field === 'removedUsers') {
        <div class="edit-item">
          <div>
            <p><b>Bewerker:</b></p>
            <p><b>Actie:</b></p>
            <p><b>Bewerking:</b></p>
          </div>
          <div class="action-list">
            <p class="edit-info">
              <span>{{ edit.editedByEmail }}</span>
              <span>{{ edit.date.toDate() | date: 'short' }}</span>
            </p>
            <p>Personen verwijderd</p>
            @for (user of change.users; track user) {
              <div>
                <p>
                  <b>{{ user.title }}</b>
                </p>
              </div>
            }
          </div>
        </div>
      }
      @if (change.field !== 'addedUsers' && change.field !== 'removedUsers') {
        <div>
          @if (change.field === 'comments') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Opmerking (Rit)</p>
                <p>{{ change.from }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'start') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Begindatum</p>
                <p>{{ change.from.toDate() | date: 'medium' }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to.toDate() | date: 'medium' }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'end') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Einddatum</p>
                <p>{{ change.from.toDate() | date: 'medium' }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to.toDate() | date: 'medium' }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'rideProduct') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Ritprijs</p>
                <p>{{ change.from.name }} - {{ change.from.cost }} Credits</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to.name }} - {{ change.to.cost }} Credits</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'special') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Rittype</p>
                <p>{{ change.from }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'vehicleId') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Voertuig</p>
                <p>{{ change.from }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'fromLocation') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Startpunt</p>
                <p>{{ change.from }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to }}</b>
                </p>
              </div>
            </div>
          }
          @if (change.field === 'toLocation') {
            <div class="edit-item">
              <div>
                <p><b>Bewerker:</b></p>
                <p><b>Actie:</b></p>
                <p><b>Bewerking:</b></p>
              </div>
              <div class="action-list">
                <p class="edit-info">
                  <span>{{ edit.editedByEmail }}</span>
                  <span>{{ edit.date.toDate() | date: 'short' }}</span>
                </p>
                <p>Bestemming</p>
                <p>{{ change.from }}</p>
                <p class="change-seperator">
                  <mat-icon>arrow_downward</mat-icon>
                  <span class="arrow-text"> is nu</span>
                </p>
                <p>
                  <b>{{ change.to }}</b>
                </p>
              </div>
            </div>
          }
        </div>
      }
    }
  }

  <h4>Voertuig</h4>
  <p>{{ deletedRide().vehicleName }}</p>
  <h4>Begintijd / Eindtijd</h4>
  <p>
    {{ deletedRide().rideData.start.toDate() | date: 'd/MM/yyyy HH:mm' }} -
    {{ deletedRide().rideData.end.toDate() | date: 'd/MM/yyyy HH:mm' }}
  </p>

  @if (!details()) {
    <div
      class="extra-info"
      role="button"
      tabindex="0"
      aria-label="Volledige ritinformatie tonen"
      (click)="details.set(!details())"
      (keydown.enter)="details.set(!details())"
      (keydown.space)="$event.preventDefault(); details.set(!details())"
    >
      <b>Toon volledige ritinformatie</b>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  }

  @if (details()) {
    <div class="info">
      @if (deletedRide().rideData.comments) {
        <div>
          <h4>Opmerking (Rit)</h4>
          <p class="remark">{{ deletedRide().rideData.comments }}</p>
        </div>
      }
      @if (deletedRide().rideData.users) {
        <div>
          <h4>Ophalen</h4>
          @for (user of users(); track user; let i = $index) {
            <div class="user">
              <div class="name">
                {{ i + 1 }}. {{ user.title }}
                @if (user.phoneNumber) {
                  <span>
                    (
                    {{ user.phoneNumber }}
                    )
                  </span>
                }
              </div>
              @if (user.userPickupTime) {
                <div class="user-time">
                  <span>Ophaaltijd:</span> {{ valueToDate(user.userPickupTime) | date: 'HH:mm' }}
                </div>
              }
              <div class="icons">
                @for (particularity of particularities(); track particularity) {
                  @if (deletedRide().rideData.rideVersion === 2 && user?.particularityIds.includes(particularity.id)) {
                    <div class="icon active" [matTooltip]="particularity.name">
                      <mat-icon [svgIcon]="particularity.id"></mat-icon>
                    </div>
                  }
                }
              </div>
              @if (user.commentsForDriver) {
                <div>
                  <h4 class="comment-for-info">Opmerking (Voor chauffeur):</h4>
                  <p class="remark participant-remark">{{ user.commentsForDriver }}</p>
                </div>
              }
              @if (user.remarkFromDriver) {
                <div>
                  <h4 class="comment-for-info">Opmerking (Van chauffeur):</h4>
                  <p class="remark participant-remark">{{ user.remarkFromDriver }}</p>
                </div>
              }
              <div class="location">
                @if (user.from.address) {
                  <p>
                    <mat-icon>location_on</mat-icon>{{ user.from.name }} -
                    {{ user.from.address }}
                  </p>
                } @else {
                  <p><mat-icon>location_on</mat-icon>{{ user.from }}</p>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (deletedRide().rideData.users) {
        <div>
          <h4>Afzetten</h4>
          @for (user of users(); track user; let i = $index) {
            <div class="user">
              <div class="name">
                {{ i + 1 }}. {{ user.title }}
                @if (user.phoneNumber) {
                  <span>
                    (
                    {{ user.phoneNumber }}
                    )
                  </span>
                }
              </div>
              @if (user.userDropoffTime) {
                <div class="user-time">
                  <span>Afzettijd:</span> {{ valueToDate(user.userDropoffTime) | date: 'HH:mm' }}
                </div>
              }
              <div class="icons">
                @for (particularity of particularities(); track particularity.id) {
                  @if (deletedRide().rideData.rideVersion === 2 && user?.particularityIds.includes(particularity.id)) {
                    <div class="icon active" [matTooltip]="particularity.name">
                      <mat-icon [svgIcon]="particularity.id"></mat-icon>
                    </div>
                  }
                }
              </div>
              @if (user.commentsForDriver) {
                <div>
                  <h4 class="comment-for-info">Opmerking (Voor chauffeur):</h4>
                  <p class="remark participant-remark">{{ user.commentsForDriver }}</p>
                </div>
              }
              @if (user.remarkFromDriver) {
                <div>
                  <h4 class="comment-for-info">Opmerking (Van chauffeur):</h4>
                  <p class="remark participant-remark">{{ user.remarkFromDriver }}</p>
                </div>
              }
              <div class="location">
                @if (user.to.address) {
                  <p>
                    <mat-icon>location_on</mat-icon>{{ user.to.name }} -
                    {{ user.to.address }}
                  </p>
                } @else {
                  <p><mat-icon>location_on</mat-icon>{{ user.to }}</p>
                }
              </div>
            </div>
          }
        </div>
      }
      <div>
        <h4>Ritprijs</h4>
        <p>{{ deletedRide().rideData.rideProduct.name }} - {{ deletedRide().rideData.rideProduct.cost }} Credits</p>
      </div>
      <div>
        <h4>Kenmerken</h4>
        <mat-chip-listbox class="chip-list">
          @for (characteristic of deletedRide().rideData.characteristics; track characteristic) {
            <mat-chip-option color="primary" selected>
              {{ characteristic }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      <div>
        <h4>Chauffeur</h4>
        <p>{{ deletedRide().driverName }}</p>
      </div>
      <div
        class="extra-info"
        role="button"
        tabindex="0"
        aria-label="Volledige ritinformatie verbergen"
        (click)="details.set(!details())"
        (keydown.enter)="details.set(!details())"
        (keydown.space)="$event.preventDefault(); details.set(!details())"
      >
        <b>Verberg volledige ritinformatie</b>
        <mat-icon>arrow_drop_up</mat-icon>
      </div>
    </div>
  }
</mat-dialog-content>
